module.exports = "mutation CreateIssueMessage($issue:CreateIssueMessageInput!){createIssueMessage(issue:$issue){success}}"